const distributionChannels = [
  {
    value: 'offline-0',
    label: '线下-品牌商'
  },
  {
    value: 'offline-1',
    label: '线下-代理商'
  },
  {
    value: 'online-0',
    label: '线上-通过web'
  },
  {
    value: 'online-1',
    label: '线上-通过app'
  }
]
export default distributionChannels
